import * as React from 'react'
import { memo } from 'react'
const SvgPhone = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 19 19"
  >
    <path d="M17.816 18.999a15.1 15.1 0 0 1-6.348-1.469 20.3 20.3 0 0 1-5.864-4.145A20.4 20.4 0 0 1 1.47 7.526 15 15 0 0 1-.001 1.184 1.16 1.16 0 0 1 .334.34a1.13 1.13 0 0 1 .838-.341h3.645a1.12 1.12 0 0 1 .747.276 1.2 1.2 0 0 1 .412.682l.641 3.288a1.9 1.9 0 0 1-.028.787 1.17 1.17 0 0 1-.34.552l-2.58 2.515a15.5 15.5 0 0 0 1.424 2.159 21 21 0 0 0 1.733 1.944 19 19 0 0 0 1.956 1.709 20 20 0 0 0 2.237 1.468l2.508-2.53a1.4 1.4 0 0 1 .635-.383 1.8 1.8 0 0 1 .775-.054l3.1.632a1.3 1.3 0 0 1 .691.432 1.1 1.1 0 0 1 .268.727v3.624a1.13 1.13 0 0 1-.341.838 1.16 1.16 0 0 1-.839.334" />
  </svg>
)
const Memo = memo(SvgPhone)
export default Memo
